<template>
  <div :class="{ fileCol: !noName }">
    <a
      v-if="!noName"
      class="fileName"
      @click="onClick"
    >{{ file ? file.name : ''}}</a>
    <FileViewer ref="fileViewer" />
  </div>
</template>

<script>
import FileViewer from '@/components/FileViewer'
import '@vue-office/docx/lib/index.css'
import '@vue-office/excel/lib/index.css'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Preview',
  components: {
    FileViewer
  },
  props: {
    file: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => ''
    }
  },
  data() {
    return {
      displacement: {
        scale: 1
      },
      pdfUrl: '',
      pdfDoc: {},
      url: '',
      show: false,
      // scale: 2,
      loading: true,
      rendered: false,
      fileName: '',
      noName: false,
      option: {
        lang: 'zh-CN',
        url: 'https://qccdata.qichacha.com/CaseSupervisePunish/1b9e6adebab3dbe695d62433a0c1d1fa.DOC',
        title: '1b9e6adebab3dbe695d62433a0c1d1fa',
        fileType: 'DOC'
      },
      scale: 1.3, // 当前缩放比例
      startX: null,
      startY: null,
      startDistance: null,
      startTransformX: 0, // 初始 X 轴偏移量
      startTransformY: 0 // 初始 Y 轴偏移量
    }
  },
  computed: {
    fileType() {
      return this.file.url.split('.').pop()
    }
    // srcUrl() {
    //   return decodeURIComponent(decodeURIComponent(this.file.url));
    // },
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.updateScale(this.scale)
    // })
  },
  methods: {
    onRendered() {
      this.$nextTick(() => {
        // const element = document.querySelector('#fileBox')

        // new EasyScroller(element, {
        //   scrollingX: true,
        //   scrollingY: true,
        //   zooming: true,
        //   minZoom: 1,
        //   maxZoom: 10.0,
        //   zoomLevel: 1.0,
        // });
      })
    },
    close() {
      this.show = false
      // document.getElementById('pdf-container')?.remove()
    },
    onClick(noName) {
      this.noName = noName === true
      // console.log('this.file.url', this.file)

      // 如果是 pdf docx .doc 浏览器打开则用浏览器打开
      if (this.file.url.indexOf('.pdf') > -1 || this.file.url.indexOf('.doc') > -1 || this.file.url.indexOf('.docx') > -1) {
        window.open(this.file.url)
        return
      }
      this.$refs.fileViewer.open(this.file.url, null, this.file?.name)
      // if (this.file.type === "file") {
      //   this.show = true;
      //   if (!this.rendered) {
      //     this.loading = true;
      //   }
      // } else if (this.file.type === "pic") {
      //   console.log("图片", [this.file.url]);
      //   // eslint-disable-next-line no-undef
      //   ImagePreview({
      //     images: [this.file.url],
      //     // startPosition: 1,
      //     onClose() {
      //       // do something
      //     },
      //   });
      // }
      // this.load(this.file.url)
    },
    handleTouchStart(e) {
      if (e.touches.length === 1) {
        // 单指触摸，记录初始位置
        this.startX = e.touches[0].clientX
        this.startY = e.touches[0].clientY
      } else if (e.touches.length === 2) {
        // 双指触摸，记录初始距离和位置
        this.startX = e.touches[0].clientX
        this.startY = e.touches[0].clientY
        this.startDistance = this.getTouchDistance(e)
      }
    },
    handleTouchMove(e) {
      if (e.touches.length === 1 && this.startX !== null) {
        // 单指移动，更新 X 和 Y 轴偏移量
        const deltaX = e.touches[0].clientX - this.startX
        const deltaY = e.touches[0].clientY - this.startY
        this.updateTransform(deltaX, deltaY)
      } else if (e.touches.length === 2 && this.startDistance) {
        // 双指移动，更新缩放比例
        const currentDistance = this.getTouchDistance(e)
        let newScale = this.scale * (currentDistance / this.startDistance)
        if (newScale < 1) {
          newScale = 1
        }
        this.updateScale(newScale)
      }
    },
    handleTouchEnd() {
      // 更新当前缩放比例和偏移量
      const transform = this.$refs.fileBox.style.transform
      const scaleMatch = transform.match(/scale\(([\d.]+)\)/)
      const translateMatch = transform.match(/translate\(([\d.]+)px, ([\d.]+)px\)/)
      if (scaleMatch) {
        this.scale = parseFloat(scaleMatch[1])
      }
      if (translateMatch) {
        this.startTransformX = parseFloat(translateMatch[1])
        this.startTransformY = parseFloat(translateMatch[2])
      }
      this.startX = this.startY = this.startDistance = null
    },
    getTouchDistance(e) {
      return Math.hypot(
        e.touches[0].clientX - e.touches[1].clientX,
        e.touches[0].clientY - e.touches[1].clientY
      )
    },
    updateScale(newScale) {
      // const box = document.querySelector('.vue-office-pdf-wrapper')
      const box = this.$refs.fileBox

      box.style.transform = `scale(${newScale}) translate(${this.startTransformX}px)`
    },
    updateTransform(deltaX, deltaY) {
      const newTransformX = this.startTransformX + deltaX
      const newTransformY = this.startTransformY + deltaY
      // const box = document.querySelector('.vue-office-pdf-wrapper')
      const box = this.$refs.fileBox

      box.style.transform = `scale(${this.scale}) translate(${newTransformX}px)`
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .vue-office-docx .docx-wrapper > section.docx {
  overflow: auto !important;
}
.loading {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  ::v-deep .van-loading__text,
  ::v-deep .van-loading {
    color: #fff;
  }

  //background: url("./images/loading.png") no-repeat center center / 100%;
  //animation: loading 1.4s infinite linear;
}
.fileCol {
  cursor: pointer;
  color: #6e3fe0;
  font-size: 24px;
  flex: 1;
  padding-right: 24px;
  .fileName {
    word-break: break-all;
  }
}
.file-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}
.file-box {
  // position: relative;
  //display: flex;
  //align-items: center;
  //justify-content: center;
  //width: 100%;
  //height: 100%;
  //overflow: auto;
  // .pdf-wrapper {
  //   width: 100%;
  //   height: 100vh;
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  //   :deep(.vue-office-pdf-wrapper) {
  //     background-color: transparent;
  //     width: 100%;
  //     height: 100%;
  //   }
  // }
  #pdf-container {
    // width: 100%;
    // height: 100vh;
    // overflow: scroll;
    // .vue-office-pdf-wrapper {
    //   background: transparent;
    // }
  }
}
.file-box {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
  touch-action: none; /* 禁用默认的触摸行为 */
}
.file-box > * {
  width: 100%;
  height: 100%;
  transition: transform 0.2s ease;
}
// .pdfBox {
//   position: relative;
//   text-align: center;
//   .buttonBox {
//     position: fixed;
//     top: 0;
//     padding: 5px 0;
//     width: 100%;
//     background: rgba(0, 0, 0, 0.1);
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     .rightButton {
//       position: absolute;
//       right: 10px;
//       cursor: pointer;
//     }
//     .enlarge {
//       display: block;
//       width: 30px;
//       height: 30px;
//       cursor: pointer;
//       //background: url("./images/icon-enlarge.png") no-repeat center center / 100%;
//     }
//     .shrink {
//       display: block;
//       width: 30px;
//       height: 30px;
//       cursor: pointer;
//       //background: url("./images/icon-shrink.png") no-repeat center center / 100%;
//     }
//   }
// }
//@keyframes loading {
//  0% {
//    transform: rotate(0deg);
//  }
//  100% {
//    transform: rotate(360deg);
//  }
//}
// :deep(.vue-office-pdf) {
//   width: 100%;
//   height: 100%;
//   canvas {
//     max-width: 100%;
//     height: auto;
//   }
// }
</style>
